import { render } from "./TrueOrFalse.vue?vue&type=template&id=309fadeb&ts=true"
import script from "./TrueOrFalse.vue?vue&type=script&lang=ts"
export * from "./TrueOrFalse.vue?vue&type=script&lang=ts"

import "./TrueOrFalse.vue?vue&type=style&index=0&id=309fadeb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__